import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RecurringPaymentArray {
  paymentType: string;
  paymentFrequency: string;
  paymentBeginDate: string;
  paymentMonth: string;
  paymentYear: string;
  amount: number;
}
interface NonRecurringPayment {
  paymentMonth: string;
  paymentYear: string;
  paymentAmount: string;
  paymentDate:string
}

interface NewLoanInfo {
  loanNumber: string;
  loanAmount: string;
  loanSetup:string;
  sourceFund: string;
  description: string;
  interestRate: string;
  term: string;
  note: string;
  disbursementDate: string;
  disbursementType: string;
  paymentDay: string;
  gracePeriod: string;
  accruedInterest: boolean;
  interestOnlyLoan: boolean;
  recurringInterestOnlyLoan: boolean;
  recurringAmount:string;
  recurringFrequency: string;
  recurringMonth: string;
   recurringYear: string;
  recuuringFlag: boolean;
  nonRecuuringFlag: boolean;
  additionalPaymentFlag: boolean;
  additionalRecurringPayment: boolean;
  additionalNonRecurringPayment: boolean;
  loanRecurringPayment: RecurringPaymentArray[];
  loanNonRecurringPayment: NonRecurringPayment[];
  nonRecurringPaymentAmount: string;
  nonRecurringPaymentMonth: string;
  nonRecurringPaymentYear: string;
  regularAmount: string;
   regularFrequency:string;
   regularMonth:string;
  regularYear:string;
  loanNumSearch:string;
  statusSearch:string;
  loanRowsPerPage:number;
  loanPage:number;
  loanId:string;
  recurringItems:string[]
  regularDate:string;
  recurringDate:string;
  loanHistoryRowsPerPage:number;
  loanHistoryPage:number;
  amortizationRowsPerPage:number;
  amortizationPage:number;
  selectedFiles:any[];
  dialogOpen:boolean;
  nxtPaymentDate:string
  autoDebt:string
  createdDate:string
}

const initialState: NewLoanInfo = {
  loanNumber: "",
  loanAmount: "",
  loanSetup:"",
  sourceFund: "",
  description: "",
  interestRate: "",
  term: "",
  note: "",
  disbursementDate: "",
  disbursementType: "ACH",
  paymentDay: "1",
  gracePeriod: "1",
  accruedInterest: false,
  interestOnlyLoan: false,
  recurringInterestOnlyLoan: false,
  recurringMonth: "",
  recurringAmount:"",
  recurringYear: "",
  recurringFrequency: "",
  recuuringFlag: false,
  nonRecuuringFlag: false,
  additionalPaymentFlag: false,
  additionalRecurringPayment: false,
  additionalNonRecurringPayment: false,
  loanRecurringPayment: [],
  loanNonRecurringPayment: [],
  nonRecurringPaymentAmount: "",
  nonRecurringPaymentMonth: "",
  nonRecurringPaymentYear: "",
  regularAmount: "",
  regularFrequency:"",
  regularMonth:"",
  regularYear:"",
  loanNumSearch:"",
  statusSearch:"All",
  loanRowsPerPage: 5,
  loanPage:0,
  loanId:"",
  recurringItems:[],
  regularDate:"",
  recurringDate:"",
  loanHistoryRowsPerPage:5,
  loanHistoryPage:0,
  amortizationRowsPerPage:5,
  amortizationPage:0,
  selectedFiles:[],
  dialogOpen:false,
  nxtPaymentDate:"",
  autoDebt:"",
  createdDate:""

};

const createNewLoanSlice = createSlice({
  name: "createNewLoan",
  initialState,
  reducers: {
    setCreateNewLoan: (state, action: PayloadAction<Partial<NewLoanInfo>>) => {
      return { ...state, ...action.payload };
    },
    removeCreateNewLoan: () => initialState,
  },
});

export const { setCreateNewLoan, removeCreateNewLoan } =
  createNewLoanSlice.actions;
export default createNewLoanSlice.reducer;
